import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faArrowLeft, faArrowRight } from "@instadeepai/fontawesome-pro-regular"
import { type Table } from "@tanstack/table-core"

import { NavigationButton, PageNumberButtons } from "./pagination-buttons"

function PaginationControls<T>({ table }: { table: Table<T> }) {
  const currentPage = table.getState().pagination.pageIndex + 1
  const totalNumberOfPages = table.getPageCount()

  const isPaginationVisible = totalNumberOfPages > 1

  return isPaginationVisible ? (
    <div className="flex h-12 flex-row items-center justify-center gap-2 border border-t-0 border-gray-200 bg-gray-100">
      <NavigationButton
        handleOnClick={() => table.previousPage()}
        disabled={!table.getCanPreviousPage()}
      >
        <FontAwesomeIcon icon={faArrowLeft} />
        <span>Previous</span>
      </NavigationButton>

      <PageNumberButtons
        currentPage={currentPage}
        totalNumberOfPages={totalNumberOfPages}
        handleOnClick={(idx) => table.setPageIndex(Number(idx))}
      />

      <NavigationButton
        handleOnClick={() => table.nextPage()}
        disabled={!table.getCanNextPage()}
      >
        <span>Next</span>
        <FontAwesomeIcon icon={faArrowRight} />
      </NavigationButton>
    </div>
  ) : null
}

export default PaginationControls
